import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar, message } from "antd";

import { useNavigate } from "react-router-dom";
import Drawer1 from "../drawer";
// import DataTable from "./DataTable";
import React, { useEffect, useRef, useState } from "react";

import "../PassportDetails.css";
import $ from "jquery";
import "datatables.net";
import BottomNavigationBar from "../BottomNavigation";
import { useSelector, useDispatch } from "react-redux";
import {
  setCountry,
  setCountryList,
  setAgent,
  setCity,
  setHotel,
  setArrivalDate_From,
  setArrivalDate_to,
  setCheckinDate,
  setCheckoutDate,
  setCompleted,
  setLength,
  clearFilter,
} from "../../Store/Slices/countrySlice";
import ArrivalDepartureGridFilter from "./ArrivalDepartureGridFilter";

function ArrivalDeparture() {
const [value, setValue] = useState(0);
  const [showDrawer, setshowDrawer] = useState(false);
  const navigate = useNavigate();
  const [voucherNo, setVoucherNo] = useState("");
  const [checkInDate, setCheckInDate] = useState("");
  const [transportType, setTransportType] = useState("");
  const [transportCompany, setTransportCompany] = useState("");
  const [vehicleNo, setVehicleNo] = useState("");
  const [actualSeat, setActualSeat] = useState("");
  const [driverNo, setDriverNo] = useState("");

  const [voucherNoError, setVoucherNoError] = useState("");
  const [checkInDateError, setCheckInDateError] = useState("");
  const [transportTypeError, setTransportTypeError] = useState("");
  const [transportCompanyError, setTransportCompanyError] = useState("");
  const [vehicleNoError, setVehicleNoError] = useState("");
  const [actualSeatError, setActualSeatError] = useState("");
  const [driverNoError, setDriverNoError] = useState("");

  const FormData = require("form-data");



  function addNewColumn() {
    var table = document.querySelector(".table");
    var rows = table.getElementsByTagName("tr");

    for (var i = 0; i < rows.length; i++) {
      var cell = document.createElement("td");
      rows[i].appendChild(cell);
    }
  }

  const handleLogout = () => {
    navigate("/login");
  };

  const handleDrawer = () => {
    setshowDrawer(true);
  };

  const tableRef = useRef(null);
  const [expandedRows, setExpandedRows] = useState([]);

  useEffect(() => {
    $(tableRef.current).DataTable();

    return () => {
      // Destroy the DataTable instance when the component unmounts
      $(tableRef.current).DataTable().destroy(true);
    };
  }, []);

  const toggleExpansion = (rowIndex) => {
    setExpandedRows((prevExpandedRows) => {
      const updatedExpandedRows = [...prevExpandedRows];
      updatedExpandedRows[rowIndex] = !updatedExpandedRows[rowIndex];
      return updatedExpandedRows;
    });
  };


  return (
    <>
    {showDrawer && <Drawer1 showDrawer={showDrawer} />}
    <div className="background-image-allow-transport">
      {/* <div className="dark-overlay"></div> */}

      <MDBContainer breakpoint=" p-4">
        <div className="">
          <div>
            <div
              className="navebar"
              style={{
                background: "",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <img className="logo" src={window.logo} alt="logo" />
              <Avatar
                className="profile"
                alt="Remy Sharp"
                src={window.profile}
              />
            </div>
            <ArrivalDepartureGridFilter />
          </div>
        </div>
      </MDBContainer>

      <div className="bottom-bar-lay">
        <BottomNavigationBar />
      </div>
    </div>
  </>
    
  )
}

export default ArrivalDeparture;